import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrPredefinedRoleDescription.ts
var t = () => e("predefinedRoleDescription");
//#endregion
export { t as useTrPredefinedRoleDescription };
